export default "__VITE_ASSET__D7z6PPB$__"